import { Password } from 'primereact/password';
import "./styles/InputZegel.scss";
const InputPastZegel = (props) => {
    return (
        <Password
            className='input-zegel password'
            {...props}
            toggleMask
            feedback={false}
        ></Password>
    );
}

export default InputPastZegel;